export default "__VITE_ASSET__vgKGnpgK__"